import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';

const HasNotSubscription: FC = () => {
  const { isLoading, subscription } = useAuthContext();

  return (
    <Middleware isLoading={isLoading}>{!subscription ? <Outlet /> : <Navigate to={Routes.DASHBOARD} />}</Middleware>
  );
};

export default HasNotSubscription;
